<template>
  <ModouiSetSidebar title="Manage Teams" />
</template>
